import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    user: null,
    authError: null,
    albums: null,
  },
  mutations: {
    setUser(state, user) {
      state.user = user
    },
    setUserFail(state, error) {
      state.user = null
      state.authError = error
    },
    patchUser(state, user) {
      Object.assign(state.user, user)
    },
    setAlbums(state, albums) {
      state.albums = albums
    },
    createAlbum(state, album) {
      state.albums.push(album)
    },
    deleteAlbum(state, albumId) {
      state.albums = state.albums.filter(x => x.id !== albumId)
    }
  },
  getters: {
    user: state => state.user,
  },
})

export default store
